import { useEffect, useRef } from "react";
import { getAuthData, getSessinIdFromLS } from "../../services/storage/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { setDomainState, setSelectedDomain } from "../../state/actions/domain";

import HomeComponent from "./components/homeComponent";
import FMConversationalBot from "../../components/tabs/FMConversationalBot";
import { SOCKET } from "../../services/socket/initWebSocket";
import provideGlobalWebSocketBridge from "../../services/socket/websocketBridge";
import { getCurrentAuthCode } from "../../utils/config/configHelpers";
import { activateEnterpriseBots } from "../../services/api/BotApiServices";
import authFunctions from "../../services/userApiServices/authFunctions";
import { loadAllDomainsListInLFStorage } from "../../services/storage/LFStorage";
import { FRONTM_DOMAIN } from "../../utils/constants";
import webSocketApiService from "../../services/socket/wsApiServices";
import { removeBotScript, removeBotStyles, removeChatInWindowScript } from "../../utils/ChatbotScriptHelpers";


const Home = () => {
  const { selectedBotId, selectedBotDetails, defaultHomePageBotId } = useSelector((state) => state.domain);
  const botWaitLoader = useSelector((state) => state.loader.botWaitLoader);
  const userDetail = getAuthData();
  const userData = userDetail.user || {}
  const selectedConversation = useSelector((state) => state.chats.selectedConversation);
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);
  const isDefaultHomePageBot = useSelector((state) => state.bot.isDefaultHomePageBot);
  const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
  const domainList = useSelector((state) => state?.domain?.domains);
  const botSubscriptions = useSelector((state) => state?.user?.botSubscriptions);
  const refreshToken = localStorage.getItem("refreshToken");
  const connectionId = localStorage.getItem("connectionId");
  const dispatch = useDispatch();


  useEffect(() => {
    removeBotScript();
    removeChatInWindowScript()
    removeBotStyles();
  }, []);

  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length > 0 && domainList.length === 0) {
      dispatch(setDomainState(true));
    }
  }, []);

const attemptedRef = useRef(false);

useEffect(() => {
  if (attemptedRef.current) return;
  if (!SOCKET?.ws || SOCKET.ws.readyState !== WebSocket.OPEN) return;

  if (userDetail && Object.keys(userDetail).length > 0 && domainList.length === 0) {
    if (userDetail.auth && userDetail.auth.newUser) {
      console.log("%cNew user detected, attempting to activate enterprise bots...%c", "color: yellow");
      const authCode = getCurrentAuthCode();
      if (authCode) {
        attemptedRef.current = true; // prevent future attempts

        activateEnterpriseBots(authCode)
          .then(async (response) => {
            const domains = response?.content ?? [];
            const corporateDomains = domains.filter(
              (domain) => domain.userDomain !== FRONTM_DOMAIN
            );
            const lastDomain = domains[domains.length - 1];
            const userDomain = lastDomain?.userDomain;

            if (userDomain) {
              await webSocketApiService.UpdateLastLoggedInDomain({ userDomain });
            }
            loadAllDomainsListInLFStorage(corporateDomains);
            // After activation completes, fetch domains from backend and continue normal flow.
            await webSocketApiService.GetUserDomains();

            if (lastDomain) {
              dispatch(setSelectedDomain(lastDomain));
            }
          })
          .catch((err) => {
            attemptedRef.current = false;
            console.error(err);
          });
      }
    }
  }
}, [SOCKET, userDetail, domainList]);

  //Provide WebSocket connection to all scripts
  useEffect(() => {
    // Initialize the global WebSocket bridge function immediately
    provideGlobalWebSocketBridge();
  }, []);


  // if (
  //   selectedDomain &&
  //   ((selectedConversation && selectedBotDetails?.customFrontEnd) || isDefaultHomePageBot)
  // ) {
  //   return (
  //     <SpinnetView
  //       baseUrl={isDefaultHomePageBot ? config.defaultHomePagebaseUrl : selectedBotDetails.customFrontEnd}
  //       botId={isDefaultHomePageBot ? defaultHomePageBotId : selectedBotId}
  //       email={userData?.emailAddress}
  //       mobileSession={sessionId || userDetail?.auth?.sessionId}
  //       appType={appType}
  //       platform="web"
  //       conversationId={
  //         isDefaultHomePageBot
  //           ? defaultHomePageBotId
  //             ? createConversationId(userData.userId, defaultHomePageBotId)
  //             : ""
  //           : selectedConversation.conversationId
  //       }
  //       userDomain={selectedDomain}
  //       refreshToken={refreshToken}
  //       connectionId={connectionId}
  //       isLoading={botWaitLoader}
  //       isDefaultHomePageBot={isDefaultHomePageBot}
  //       botSubscriptions={botSubscriptions}
  //     />
  //   );
  // }

  if (selectedBotDetails?.conversational || selectedBotDetails?.systemBot || isAssistantBotOpen) {
    return <FMConversationalBot
      refreshToken={refreshToken}
      connectionId={connectionId}
    />
  }

  return <HomeComponent isLoading={botWaitLoader} refreshToken={refreshToken}
    connectionId={connectionId} />
};

export default Home;
